<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud :ref="'messageTypesCrud'" crudName="Tipos de Mensagem" newText="Novo Tipo de Mensagem" :table="table"
          :columns="columns" :options="options" :endPoint="endPoint" :enableAdd="true" :enableEdit="true"
          :enableDelete="true" :enableView="false" :dataForm="dataForm">
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "messageTypesTable",
      showMessageImport: false,
      messageTypesCrud: {},
      pages: [],
      url: "",
      columns: ["id", "description", "status", "call_status_id", "actions"],
      tableData: ["id", "description", "status", "call_status_id"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["description", "status"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          description: "Título",
          status: "Status",
          call_status_id: "Vínculo",
          actions: "Ações",
        },
        sortable: [],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          status: [
            {
              id: 1,
              text: "Ativo",
            },
            {
              id: 0,
              text: "Inativo",
            },
          ],
        },
        templates: {
          status: function (h, row, index) {
            return row.status == 1
              ? "Ativo"
              : row.status == 0
                ? "Inativo"
                : "Inativo";
          },
          call_status_id: function (h, row, index) {
            return row.call_status ? row.call_status.description : "Não vinculado";
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;

          requestData.params.query = "";
          requestData.params.with = ["call_status"];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "message_types/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let fileImport = document.getElementById("fileImport");

      fd.append("fileImport", fileImport.files[0] ? fileImport.files[0] : "");

      return fd;
    },
    importFile() {
      const self = this;
      let api = self.$store.state.api + "import-users";

      let fd = self.makeFormData();

      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.showMessageImport = true;
          self.$refs.usersCrud.$refs.table.refresh();
        })
        .catch((error) => {
          self.$message(
            "Ops",
            "Houve um erro durante a importação da planilha, verifique a planilha e tente novamente.",
            "error"
          );
        });
    },
    query: function (query) {
      let columns = {
        id: "id",
        description: "description",
        status: "status",
        call_status_id: "call_status_id",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
    openInput() {
      document.getElementById("fileImport").click();
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>